<template>
    <div class="sr-base-tooltip-wrapper">
        <slot name="activator" :on="listeners" />
        <div v-show="active" :class="positionClasses" class="sr-base-tooltip">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SrTooltip',
    props: {
        left: {
            type: Boolean,
            default: false,
        },
        right: {
            type: Boolean,
            default: false,
        },
        top: {
            type: Boolean,
            default: false,
        },
        bottom: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            listeners: {
                mouseenter: this.open,
                mouseleave: this.close,
                focus: this.open,
                blur: this.close,
            },
            active: false,
        };
    },
    computed: {
        positionClasses() {
            return {
                'sr-base-tooltip-right': this.right,
                'sr-base-tooltip-left': this.left,
                'sr-base-tooltip-top': this.top,
                'sr-base-tooltip-bottom': this.bottom,
            };
        },
    },
    methods: {
        open() {
            this.active = true;
        },
        close() {
            this.active = false;
        },
    },
};
</script>
